import { ComparisonOperator, Field, FieldType } from "../../vforms-model";
import { EmailFieldComponent } from "./email.component";
import { EmailFieldEditorComponent } from "./email-editor.component";
import { TextBox } from "../text-box/text-box";
import { ComparisonExpression } from "../../expression-settings/model";

export class EmailFieldType extends FieldType {
    static Id = "email";

    constructor() {
        super();
        this.id = EmailFieldType.Id;
        this.icon = "mat_outline:alternate_email";
        this.previewComponent = EmailFieldComponent;
        this.editorComponent = EmailFieldEditorComponent;
    }

    createField(): Field {
        return new EmailField(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [
            ...super.supportedComparisonOperators(),
            ComparisonOperator.Equal,
            ComparisonOperator.NotEqual,
            ComparisonOperator.Contains,
            ComparisonOperator.NotContains,
        ];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        let lowerCaseValue = value?.toLowerCase();
        let lowerCaseExpressionValue = expression.value.toLowerCase();
        switch (expression.operator) {
            case ComparisonOperator.Equal:
                return lowerCaseValue === lowerCaseExpressionValue;
            case ComparisonOperator.NotEqual:
                return lowerCaseValue != lowerCaseExpressionValue;
            case ComparisonOperator.Contains:
                return value && lowerCaseValue.includes(lowerCaseExpressionValue);
            case ComparisonOperator.NotContains:
                return !value || !lowerCaseValue.includes(lowerCaseExpressionValue);
        }

        return super.evaluate(expression, value);
    }
}

export class EmailField extends TextBox {}
